import React from 'react'
import PropTypes from 'prop-types'
import Authors from './Authors'
import { formatDate } from '../utils'

const EpisodeMeta = (props) => {
  return(
    <>
      <span>vom {formatDate(new Date(props.published))} - Dauer {props.duration}</span>
      <br />
      <Authors authors={props.authors} />
    </>
  )
}

EpisodeMeta.propTypes = {
  duration: PropTypes.string.isRequired,
  published: PropTypes.string.isRequired,
  authors: PropTypes.array.isRequired
}
export default EpisodeMeta
